export default {
  zh: {
    common: {
      appName: '地震预测系统',
      appShortName: '地震预测',
      // common.js 的 zh 部分，在 common: { ... } 内新增：
      home: {
        title: '地震预测系统',
        subtitle: 'Earthquake Prediction System',
        card: {
          mapTitle: '地震预测地图',
          mapDesc: '在地图上查看预测点、实际发生点及区域',
          predictTitle: '预测数据管理',
          predictDesc: '录入、编辑、发布地震预测与结果数据'
        },
        footer: '© 2026 地震预测系统 v1.0',
        langTip: '切换语言 / Switch Language'
      },
      // 通用按钮
      btn: {
        confirm: '确定',
        cancel: '取消',
        save: '保存',
        submit: '提交',
        search: '查询',
        reset: '重置',
        close: '关闭',
        back: '返回',
        backHome: '回到首页',
        add: '新增',
        edit: '编辑',
        delete: '删除',
        view: '查看',
        detail: '详情',
        refresh: '刷新',
        export: '导出',
        loading: '加载中...'
      },
      // 通用提示
      msg: {
        success: '操作成功',
        fail: '操作失败',
        warning: '警告',
        tip: '提示',
        loading: '加载中...',
        noData: '暂无数据',
        networkError: '网络异常，请稍后重试',
        serverError: '服务器异常，请稍后重试',
        unauthorized: '会话已过期，请刷新页面',
        forbidden: '无权限访问',
        notFound: '请求的资源不存在',
        confirmDelete: '确定删除吗？',
        operationSuccess: '操作成功',
        operationFail: '操作失败'
      },
      // 语言切换
      lang: {
        label: '语言',
        zh: '中文',
        en: 'English',
        switchSuccess: '语言已切换'
      },
      // 通用单位
      unit: {
        km: 'km',
        m: 'm',
        day: '天',
        days: '天',
        hour: '小时',
        minute: '分钟',
        degree: '°'
      },
      // 时区提示（迪拜部署用）
      timezone: {
        tip: '时间以浏览器本地时区显示',
        utc: 'UTC',
        dubai: '迪拜时间 (UTC+4)'
      },
      // 通用字段
      field: {
        operation: '操作',
        status: '状态',
        remark: '备注',
        createTime: '创建时间',
        updateTime: '更新时间',
        createBy: '创建人',
        updateBy: '更新人',
        yes: '是',
        no: '否',
        show: '显示',
        hide: '隐藏',
        enabled: '启用',
        disabled: '禁用',
        all: '全部'
      },
      // 时间选择器
      datePicker: {
        now: '此刻',
        today: '今天',
        cancel: '取消',
        clear: '清空',
        confirm: '确定',
        selectDate: '选择日期',
        selectTime: '选择时间',
        startDate: '开始日期',
        startTime: '开始时间',
        endDate: '结束日期',
        endTime: '结束时间',
        prevMonth: '上个月',
        nextMonth: '下个月',
        prevYear: '上一年',
        nextYear: '下一年',
        selectMonth: '选择月份',
        selectYear: '选择年份',
        week: '周'
      },
      serverMsg: {
        '用户名或密码错误': '用户名或密码错误',
        '会话已过期，请刷新页面': '会话已过期，请刷新页面',
        '无权限访问': '无权限访问',
        '数据不存在': '数据不存在',
        '参数校验失败': '参数校验失败',
        '服务器内部错误': '服务器内部错误',
        '操作成功': '操作成功',
        '删除失败': '删除失败'
      },
    }
  },
  en: {
    common: {
      appName: 'Earthquake Prediction System',
      appShortName: 'EQ Prediction',
      // common.js 的 en 部分，在 common: { ... } 内新增：
      home: {
        title: 'Earthquake Prediction System',
        subtitle: '地震预测系统',
        card: {
          mapTitle: 'Prediction Map',
          mapDesc: 'View predictions, actual events and plate regions on the map',
          predictTitle: 'Prediction Data',
          predictDesc: 'Create, edit and publish earthquake prediction and result data'
        },
        footer: '© 2026 Earthquake Prediction System v1.0',
        langTip: 'Switch Language / 切换语言'
      },
      btn: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        save: 'Save',
        submit: 'Submit',
        search: 'Search',
        reset: 'Reset',
        close: 'Close',
        back: 'Back',
        backHome: 'Back to Home',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        detail: 'Detail',
        refresh: 'Refresh',
        export: 'Export',
        loading: 'Loading...'
      },
      msg: {
        success: 'Success',
        fail: 'Failed',
        warning: 'Warning',
        tip: 'Tip',
        loading: 'Loading...',
        noData: 'No data',
        networkError: 'Network error, please try again later',
        serverError: 'Server error, please try again later',
        unauthorized: 'Session expired, please refresh the page',
        forbidden: 'Access denied',
        notFound: 'Resource not found',
        confirmDelete: 'Are you sure to delete?',
        operationSuccess: 'Operation succeeded',
        operationFail: 'Operation failed'
      },
      lang: {
        label: 'Language',
        zh: '中文',
        en: 'English',
        switchSuccess: 'Language switched'
      },
      unit: {
        km: 'km',
        m: 'm',
        day: 'day',
        days: 'days',
        hour: 'hour',
        minute: 'minute',
        degree: '°'
      },
      timezone: {
        tip: 'Times are displayed in your local timezone',
        utc: 'UTC',
        dubai: 'Dubai Time (UTC+4)'
      },
      field: {
        operation: 'Actions',
        status: 'Status',
        remark: 'Remark',
        createTime: 'Created At',
        updateTime: 'Updated At',
        createBy: 'Created By',
        updateBy: 'Updated By',
        yes: 'Yes',
        no: 'No',
        show: 'Show',
        hide: 'Hide',
        enabled: 'Enabled',
        disabled: 'Disabled',
        all: 'All'
      },
      datePicker: {
        now: 'Now',
        today: 'Today',
        cancel: 'Cancel',
        clear: 'Clear',
        confirm: 'OK',
        selectDate: 'Select date',
        selectTime: 'Select time',
        startDate: 'Start Date',
        startTime: 'Start Time',
        endDate: 'End Date',
        endTime: 'End Time',
        prevMonth: 'Previous Month',
        nextMonth: 'Next Month',
        prevYear: 'Previous Year',
        nextYear: 'Next Year',
        selectMonth: 'Select Month',
        selectYear: 'Select Year',
        week: 'Week'
      },
      serverMsg: {
        '用户名或密码错误': 'Invalid username or password',
        '会话已过期，请刷新页面': 'Session expired, please refresh the page',
        '无权限访问': 'Access denied',
        '数据不存在': 'Data not found',
        '参数校验失败': 'Parameter validation failed',
        '服务器内部错误': 'Internal server error',
        '操作成功': 'Success',
        '删除失败': 'Delete failed'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/modules/common.js